module.exports = __webpack_public_path__ + "static/flasche-romanis-medium-49e0b915938aac26036761025268382b.png";